<ng-container *ngIf="tenantConfig$ | async as tenantConfig">
  <div class="wrapper">
    <div class="col" class="action-buttons">
      <app-custom-button
        *ngFor="let action of actions"
        [show]="showActionButton(action, tenantConfig)"
        [disable]="disableButton(action)"
        [infoInButton]="action.infoInButton"
        [title]="action.actionName"
        (onClick)="onButtonClicked(action)"></app-custom-button>
    </div>

    <ng-content></ng-content>
  </div>
</ng-container>
